import { sendRequest as apiSendRequest } from 'api/feedback'

export const sendRequest = payload => async dispatch => {
  const result = await dispatch(apiSendRequest(payload))
  return result
}
